document.addEventListener('DOMContentLoaded', function() {
  // Function to get a cookie by name
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  // Function to set a cookie
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
  }

  // Function to get the browser's language
  function getBrowserLanguage() {
    return navigator.language || navigator.userLanguage;
  }

  // Function to get the site's language from the URL
  function getSiteLanguage() {
    const url = window.location.href;
    if (url.includes(".dk/en")) {
      return "en";
    } else if (url.includes(".dk")) {
      return "da";
    }
    return "en"; // Default language
  }

  // Function to display the language popup
  function showLanguagePopup(siteLanguage) {
    const message = siteLanguage === 'da'
      ? 'Er du sikker på du vil fortsætte på dansk?'
      : 'Are you sure you want to browse in English?';
    const continueButton = siteLanguage === 'da'
      ? 'Fortsæt på dansk'
      : 'Continue in English';
    const switchButton = siteLanguage === 'da'
      ? 'Switch to English'
      : 'Skift til dansk';

    const popup = document.createElement('div');
    popup.innerHTML = `
      <div id="language-popup" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; z-index: 10000;">
        <div style="background: white; padding: 20px; text-align: center;">
          <p>${message}</p>
          <button id="continue-button" style="margin: 5px;">${continueButton}</button>
          <button id="switch-button" style="margin: 5px;">${switchButton}</button>
        </div>
      </div>
    `;
    document.body.appendChild(popup);

    document.getElementById('continue-button').addEventListener('click', function() {
      setCookie('preferredLanguage', siteLanguage, 365);
      document.getElementById('language-popup').remove();
    });

    document.getElementById('switch-button').addEventListener('click', function() {
      const newLang = siteLanguage === 'da' ? 'en' : 'da';
      setCookie('preferredLanguage', newLang, 365);
      const languageLink = document.querySelector(`a[data-language-code="${newLang}"]`);
      if (languageLink) {
        languageLink.click();
      } else {
        // Fallback to URL manipulation if language switcher link is not available
        if (newLang === 'en') {
          window.location.href = window.location.href.replace('.dk', '.dk/en');
        } else {
          window.location.href = window.location.href.replace('/en', '');
        }
      }
    });
  }

  // Check if the popup should be shown
  const preferredLanguage = getCookie('preferredLanguage');
  const browserLanguage = getBrowserLanguage().substring(0, 2); // Get the first 2 characters (language code)
  const siteLanguage = getSiteLanguage();

  if (!preferredLanguage) {
    if ((siteLanguage === 'da' && browserLanguage !== 'da') || (siteLanguage === 'en' && browserLanguage === 'da')) {
      showLanguagePopup(siteLanguage);
    }
  }
});